module.exports = __webpack_public_path__ + "img/girdAdd.198902fd.svg";